import React, { useEffect } from 'react'
import { Box, Button, Drawer, IconButton, Typography } from '@mui/material'
import { IconFilter, IconX } from '@tabler/icons-react'
import { FormProvider, useForm } from 'react-hook-form'
import { CheckboxMultiple } from '~/components/Form/CheckboxMultiple'
import { Input } from '~/components/Form/Input'
import { SearchQueysData, useQueryString } from '~/hooks'
import { EAffiliatePartnerUserStatus } from '~/graphql/types'

type FilterData = {
  status?: string[]
  partnerId?: string
}

type FilterPartnerUserDrawerProps = {
  drawerIsOpen: boolean
  setDrawerIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  toggleDrawer: () => void
  queryKeys: SearchQueysData[]
}

const partnerUserStatusOptions = [
  { value: EAffiliatePartnerUserStatus.underAnalysis, label: 'Em análise' },
  { value: EAffiliatePartnerUserStatus.approved, label: 'Aprovado' },
  { value: EAffiliatePartnerUserStatus.rejected, label: 'Reprovado' },
]

export const FilterPartnerUserDrawer: React.FC<FilterPartnerUserDrawerProps> = ({ drawerIsOpen, toggleDrawer, setDrawerIsOpen, queryKeys }) => {
  const formMethods = useForm<FilterData>()

  const { searchQuerys, setSearchParams } = useQueryString()
  const queryValues = searchQuerys(queryKeys)

  useEffect(() => {
    if (drawerIsOpen) {
      formMethods.setValue('status', queryValues.status)
      formMethods.setValue('partnerId', queryValues.partnerId)
    }
  }, [drawerIsOpen])

  const handleFilters = (filters: FilterData) => {
    setDrawerIsOpen(false)
    setSearchParams(state => {
      state.set('page', '0')
      if (filters?.status && filters?.status?.length > 0 || queryValues?.status?.length > 0) {
        state.set('status', JSON.stringify(filters.status) || queryValues.status)
      } else {
        state.delete('status')
      }

      if (filters?.partnerId || queryValues?.partnerId) {
        state.set('partnerId', filters.partnerId || queryValues.partnerId)
      } else {
        state.delete('partnerId')
      }
      return state
    })
  }

  const onRemoveFilters = () => {
    setDrawerIsOpen(false)
    setSearchParams(state => {
      state.set('page', '0')
      state.delete('status')
      state.delete('partnerId')
      return state
    })
  }

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<IconFilter size={18} />}
        onClick={toggleDrawer}
        sx={{ whiteSpace: 'nowrap', minWidth: 'auto' }}
      >
        Filtrar
      </Button>

      <Drawer PaperProps={{ sx: { maxWidth: '560px', width: '100%', padding: '2rem' } }} anchor='right' open={drawerIsOpen} onClose={toggleDrawer}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography fontWeight={500} variant='h5'>Filtrar por</Typography>
          <IconButton type='button' onClick={() => toggleDrawer()}>
            <IconX />
          </IconButton>
        </Box>

        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit((formData) => handleFilters(formData))}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem', mt: '2rem' }}>
              <Box>
                <Typography fontWeight={500} sx={{ mb: 1 }}>Status</Typography>
                <CheckboxMultiple name='status' options={partnerUserStatusOptions} />
              </Box>

              <Box>
                <Typography fontWeight={500} sx={{ mb: 1 }}>Representante Comercial</Typography>
                <Input name='partnerId' label='ID do Representante' placeholder='Digite o ID do representante...' />
              </Box>
            </Box>

            <Box sx={{ display: 'flex', padding: '2rem 0', gap: '1rem', justifyContent: 'flex-end' }}>
              <Button onClick={() => onRemoveFilters()} type='button' fullWidth color='secondary'>Limpar</Button>
              <Button type='submit' fullWidth color='primary'>Aplicar</Button>
            </Box>
          </form>
        </FormProvider>
      </Drawer>
    </>
  )
}
